// Uppgifter som återanvänds mellan dokument, så att samma fält bara
// behöver fyllas i en gång. Sparas lokalt och används vid nyskapande.
export interface CarryOverData {
  projektnamn: string;
  bestallare: string;
  plats: string;
  entreprenor: string;
  kontaktperson: string;
  updatedAt?: number;
}

const KEY = "bams.carryOver";

export const EMPTY_CARRY_OVER: CarryOverData = {
  projektnamn: "",
  bestallare: "",
  plats: "",
  entreprenor: "",
  kontaktperson: "",
};

export function readCarryOver(): CarryOverData {
  if (typeof window === "undefined") return EMPTY_CARRY_OVER;
  try {
    const raw = window.localStorage.getItem(KEY);
    return raw ? { ...EMPTY_CARRY_OVER, ...(JSON.parse(raw) as CarryOverData) } : EMPTY_CARRY_OVER;
  } catch {
    return EMPTY_CARRY_OVER;
  }
}

export function writeCarryOver(data: Partial<CarryOverData>) {
  if (typeof window === "undefined") return;
  const next = { ...readCarryOver(), ...data, updatedAt: Date.now() };
  window.localStorage.setItem(KEY, JSON.stringify(next));
  window.dispatchEvent(new CustomEvent("bams:carryOver"));
}

export function clearCarryOver() {
  window.localStorage.removeItem(KEY);
  window.dispatchEvent(new CustomEvent("bams:carryOver"));
}

/** Antal ifyllda fält – används för att visa hur mycket som förs över. */
export const carryOverFilledCount = (data: CarryOverData): number =>
  [data.projektnamn, data.bestallare, data.plats, data.entreprenor, data.kontaktperson].filter(
    (v) => v.trim().length > 0
  ).length;

/** Föreslår ett dokumentnamn utifrån det som redan är känt. */
export function suggestDocName(defaultName: string, data: CarryOverData): string {
  const base = data.projektnamn.trim();
  return base ? `${base} – ${defaultName}` : defaultName;
}

/** Beskrivning som följer med det nya dokumentet. */
export function carryOverDescription(data: CarryOverData): string {
  const parts: string[] = [];
  if (data.bestallare.trim()) parts.push(`Beställare: ${data.bestallare.trim()}`);
  if (data.plats.trim()) parts.push(`Plats: ${data.plats.trim()}`);
  if (data.entreprenor.trim()) parts.push(`Entreprenör: ${data.entreprenor.trim()}`);
  if (data.kontaktperson.trim()) parts.push(`Kontakt: ${data.kontaktperson.trim()}`);
  return parts.join(" · ");
}
